import { AxiosResponse } from "axios";
import API from "../api";
import BaseService from "./_base.service";
import { LiftvanConfig } from "../models/liftvan.config";

const endpoint = "liftvan-config";

const LiftvanConfigService = {
  ...BaseService<LiftvanConfig>({ endpoint }),

  async create(data: LiftvanConfig): Promise<AxiosResponse<LiftvanConfig>> {
    return await API.post(`${endpoint}`, data);
  },

  async getByJobId(jobId: number): Promise<AxiosResponse<LiftvanConfig>> {
    return await API.get(`${endpoint}/job/${jobId}`);
  },

  async update(data: LiftvanConfig): Promise<AxiosResponse<boolean>> {
    return await API.put(`${endpoint}/${data.id}`, data);
  },
};

export default LiftvanConfigService;
